// API Configuration
// Centralized configuration for all API endpoints

// Base URLs from environment variables
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';

// API Endpoints - Complete list of all backend endpoints
export const API_ENDPOINTS = {
 // Authentication
 STUDENT_LOGIN: `${API_BASE_URL}/student/login`,
 STUDENT_SIGNUP: `${API_BASE_URL}/student/signup`,
 UNIVERSITY_LOGIN: `${API_BASE_URL}/university/login`,
 UNIVERSITY_SIGNUP: `${API_BASE_URL}/university/signup`,
 ADMIN_LOGIN: `${API_BASE_URL}/admin/login`,
 VERIFY_BETA_CODE: `${API_BASE_URL}/auth/verify-beta-code`,
 VERIFY_BYPASS_TOKEN: `${API_BASE_URL}/auth/verify-bypass-token`,


 // Password Reset
 STUDENT_FORGOT_PASSWORD: `${API_BASE_URL}/student/forgot-password`,
 UNIVERSITY_FORGOT_PASSWORD: `${API_BASE_URL}/university/forgot-password`,
 STUDENT_VALIDATE_RESET_TOKEN: (token) => `${API_BASE_URL}/student/validate-reset-token/${token}`,
 UNIVERSITY_VALIDATE_RESET_TOKEN: (token) => `${API_BASE_URL}/university/validate-reset-token/${token}`,
 STUDENT_RESET_PASSWORD: (token) => `${API_BASE_URL}/student/reset-password/${token}`,
 UNIVERSITY_RESET_PASSWORD: (token) => `${API_BASE_URL}/university/reset-password/${token}`,

 // Email Verification
 VERIFY_EMAIL: (token) => `${API_BASE_URL}/auth/verify-email/${token}`,
 RESEND_VERIFICATION: `${API_BASE_URL}/auth/resend-verification`,


 // Profile Management
 PROFILE: `${API_BASE_URL}/profile`,
 STUDENT_UPDATE_PROFILE: `${API_BASE_URL}/student/update-profile`,
 UNIVERSITY_UPDATE_PROFILE: `${API_BASE_URL}/university/update-profile`,
 UPLOAD_PROFILE_PICTURE: `${API_BASE_URL}/upload-profile-picture`,
 UPLOAD_COVER_PHOTO: `${API_BASE_URL}/upload-cover-photo`,

 // Password & Account Management
 STUDENT_CHANGE_PASSWORD: `${API_BASE_URL}/student/change-password`,
 UNIVERSITY_CHANGE_PASSWORD: `${API_BASE_URL}/university/change-password`,
 STUDENT_DELETE_ACCOUNT: `${API_BASE_URL}/student/delete-account`,
 UNIVERSITY_DELETE_ACCOUNT: `${API_BASE_URL}/university/delete-account`,

 // Contact
 CONTACT_FORM: `${API_BASE_URL}/contact`,
 WAITLIST: `${API_BASE_URL}/waitlist`,

 // Universities
 FEATURED_UNIVERSITIES: `${API_BASE_URL}/featured-universities`,
 UNIVERSITY_DETAIL: (id) => `${API_BASE_URL}/university/${id}`,
 UNIVERSITY_UPDATE_INFO: `${API_BASE_URL}/university/update-info`,

 // Programs
 PROGRAMS: `${API_BASE_URL}/programs`,
 UNIVERSITY_PROGRAMS: (id) => `${API_BASE_URL}/university/${id}/programs`,
 PROGRAM_DELETE: (id) => `${API_BASE_URL}/programs/${id}`,
 PROGRAM_UPDATE: (id) => `${API_BASE_URL}/programs/${id}`,

 // Campus Facilities
 CAMPUS_FACILITIES: (universityId) => `${API_BASE_URL}/university/${universityId}/campus-facilities`,
 CAMPUS_FACILITY_DELETE: (facilityId) => `${API_BASE_URL}/campus-facility/${facilityId}`,

 // Dropdown Data
 CITIES: `${API_BASE_URL}/cities`,
 GENDERS: `${API_BASE_URL}/genders`,
 FIELDS_OF_STUDY: `${API_BASE_URL}/fields-of-study`,
 UNIVERSITY_TYPES: `${API_BASE_URL}/university-types`,
 DEGREE_TYPES: `${API_BASE_URL}/degree-types`,

 // Fee Structure
 UNIVERSITY_FEES: (id) => `${API_BASE_URL}/university/${id}/fees`,
 FEES_SUMMARY: `${API_BASE_URL}/fees/summary`,
 FEE_STRUCTURE: `${API_BASE_URL}/fee-structure`,
 FEE_STRUCTURE_BULK: `${API_BASE_URL}/fee-structure/bulk`,

 // Admin Panel
 ADMIN_STATISTICS: `${API_BASE_URL}/admin/statistics`,
 ADMIN_PROFILE: `${API_BASE_URL}/admin/profile`,
 ADMIN_PROFILE_UPDATE: `${API_BASE_URL}/admin/profile`,
 ADMIN_PROFILE_CHANGE_PASSWORD: `${API_BASE_URL}/admin/profile/change-password`,
 ADMIN_PROFILE_UPLOAD_PHOTO: `${API_BASE_URL}/admin/profile/upload-photo`,
 ADMIN_STUDENTS: `${API_BASE_URL}/admin/students`,
 ADMIN_UNIVERSITIES: `${API_BASE_URL}/admin/universities`,
 ADMIN_PROGRAMS: `${API_BASE_URL}/admin/programs`,
 ADMIN_EXAM_ATTEMPTS: `${API_BASE_URL}/admin/exam-attempts`,
 ADMIN_RESET_EXAM_ATTEMPTS: (examId, studentId) => `${API_BASE_URL}/admin/exams/${examId}/students/${studentId}/reset-attempts`,
 ADMIN_STUDENT_DELETE: (id) => `${API_BASE_URL}/admin/students/${id}`,
 ADMIN_UNIVERSITY_DELETE: (id) => `${API_BASE_URL}/admin/universities/${id}`,
 ADMIN_STUDENT_TOGGLE: (id) => `${API_BASE_URL}/admin/students/${id}/toggle-status`,
 ADMIN_UNIVERSITY_TOGGLE: (id) => `${API_BASE_URL}/admin/universities/${id}/toggle-status`,
 ADMIN_OPTIMIZE_DATABASE: `${API_BASE_URL}/admin/optimize-database`,
 ADMIN_OPTIMIZATION_STATUS: `${API_BASE_URL}/admin/optimization-status`,
 ADMIN_CREATE_TABLES: `${API_BASE_URL}/admin/create-tables`,
 ADMIN_INIT_DATABASE: `${API_BASE_URL}/admin/init-database`,
 ADMIN_CANONICAL_PROGRAMS: `${API_BASE_URL}/admin/canonical-programs`,
 ADMIN_CANONICAL_DETAIL: (id) => `${API_BASE_URL}/admin/canonical-programs/${id}`,
 ADMIN_CANONICAL_OFFERINGS: (id) => `${API_BASE_URL}/admin/canonical-programs/${id}/offerings`,
 ADMIN_CANONICAL_ALIASES: (id) => `${API_BASE_URL}/admin/canonical-programs/${id}/aliases`,
 ADMIN_CANONICAL_UNLINKED: `${API_BASE_URL}/admin/canonical-programs/unlinked`,
 ADMIN_CANONICAL_AUTO_MATCH: `${API_BASE_URL}/admin/canonical-programs/auto-match`,
 ADMIN_CANONICAL_LINK_OFFERING: `${API_BASE_URL}/admin/canonical-programs/link-offering`,
 ADMIN_INFER_CANONICAL: `${API_BASE_URL}/admin/canonical-programs/infer`,
 ADMIN_AUDIT_LOGS: `${API_BASE_URL}/admin/audit-logs`,

 // Health Checks
 HEALTH: `${BACKEND_BASE_URL}/health`,
 DATABASE_HEALTH: `${API_BASE_URL}/health/database`,

 // Blog / CMS
 BLOGS: `${API_BASE_URL}/blogs`,
 BLOG_DETAIL: (slug) => `${API_BASE_URL}/blogs/${slug}`,
 BLOG_CATEGORIES: `${API_BASE_URL}/blog-categories`,
 BLOG_TAGS: `${API_BASE_URL}/blog-tags`,
 ADMIN_BLOGS: `${API_BASE_URL}/admin/blogs`,
 ADMIN_BLOG_DETAIL: (id) => `${API_BASE_URL}/admin/blogs/${id}`,
 ADMIN_BLOG_PUBLISH: (id) => `${API_BASE_URL}/admin/blogs/${id}/publish`,
 ADMIN_BLOG_UNPUBLISH: (id) => `${API_BASE_URL}/admin/blogs/${id}/unpublish`,
 ADMIN_BLOG_IMAGE_UPLOAD: `${API_BASE_URL}/admin/blogs/images`,
 ADMIN_BLOG_CATEGORIES: `${API_BASE_URL}/admin/blog-categories`,
 ADMIN_BLOG_CATEGORY: (id) => `${API_BASE_URL}/admin/blog-categories/${id}`,
 ADMIN_BLOG_TAGS: `${API_BASE_URL}/admin/blog-tags`,

 // Exams
 UNIVERSITY_EXAMS: `${API_BASE_URL}/exams/university`,
 UNIVERSITY_EXAM_DETAIL: (examId) => `${API_BASE_URL}/exams/university/${examId}`,
 UNIVERSITY_EXAM_PROGRAMS: `${API_BASE_URL}/exams/university/programs`,
 UNIVERSITY_EXAM_MATERIALS: (examId) => `${API_BASE_URL}/exams/university/${examId}/materials`,
 UNIVERSITY_GENERATE_EXAM_QUESTIONS: (examId) => `${API_BASE_URL}/exams/university/${examId}/generate-questions`,
 UNIVERSITY_EXAM_RESULTS: `${API_BASE_URL}/exams/university/results`,
 UNIVERSITY_EXAM_ATTEMPT_DETAIL: (attemptId) => `${API_BASE_URL}/exams/university/results/${attemptId}/detail`,
 UNIVERSITY_STUDENT_SUMMARY: (studentId) => `${API_BASE_URL}/exams/university/students/${studentId}/summary`,
 UNIVERSITY_EXAM_QUESTION_POOL: (examId) => `${API_BASE_URL}/exams/university/${examId}/questions`,
 STUDENT_AVAILABLE_EXAMS: `${API_BASE_URL}/exams/student/available`,
 STUDENT_EXAM_ATTEMPTS: `${API_BASE_URL}/exams/student/attempts`,
 STUDENT_START_EXAM: (examId) => `${API_BASE_URL}/exams/student/${examId}/start`,
 STUDENT_SUBMIT_ATTEMPT: (attemptId) => `${API_BASE_URL}/exams/student/attempts/${attemptId}/submit`,

 // Debug
 DEBUG_STUDENT: (id) => `${API_BASE_URL}/debug/student/${id}`,
};

// Default headers for API requests
export const DEFAULT_HEADERS = {
 'Content-Type': 'application/json',
};

// Helper function to get authorization headers
export const getAuthHeaders = (token) => ({
 ...DEFAULT_HEADERS,
 'Authorization': `Bearer ${token}`,
});

// Helper function to make API requests
export const apiRequest = async (url, options = {}) => {
 const config = {
 headers: DEFAULT_HEADERS,
 ...options,
 };

 try {
 const response = await fetch(url, config);
 const data = await response.json();

 if (!response.ok) {
 throw new Error(data.error || `HTTP error! status: ${response.status}`);
 }

 return data;
 } catch (error) {
 console.error('API request failed:', error);
 throw error;
 }
};

// Helper function to make authenticated API requests
export const authenticatedApiRequest = async (url, token, options = {}) => {
 return apiRequest(url, {
 ...options,
 headers: getAuthHeaders(token),
 });
};

export default {
 API_BASE_URL,
 BACKEND_BASE_URL,
 FRONTEND_BASE_URL,
 API_ENDPOINTS,
 DEFAULT_HEADERS,
 getAuthHeaders,
 apiRequest,
 authenticatedApiRequest,
};
